import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { adminDeleteComment, fetchUserComments } from '../lib/superadminUsersApi';

const UserComments: React.FC = () => {
  const params = useParams();
  const idNum = Number(params.id || '');
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);
  const [data, setData] = useState<any>({ total: 0, rows: [] });
  const [search, setSearch] = useState('');
  const [pending, setPending] = useState('');

  useEffect(() => { const t = setTimeout(() => setSearch(pending), 300); return () => clearTimeout(t); }, [pending]);

  const load = async () => {
    try {
      setLoading(true);
      const res = await fetchUserComments(idNum, { search, limit: 50, order: 'desc', sort: 'createdAt' });
      setData(res);
    } catch (e: any) {
      setError(e?.message || 'Failed to load');
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => { load(); // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [idNum, search]);

  const onDelete = async (id: number) => { if (!window.confirm('Delete comment?')) return; await adminDeleteComment(id); await load(); };

  return (
    <div className="space-y-4">
      <div className="bg-white rounded shadow p-4">
        <div className="flex gap-3">
          <input className="border rounded px-3 py-2 w-full" placeholder="Search" value={pending} onChange={(e) => setPending(e.target.value)} />
        </div>
      </div>
      {loading ? <div>Loading…</div> : error ? <div className="text-red-600">{error}</div> : (
        <div className="overflow-x-auto bg-white rounded shadow">
          <table className="min-w-full text-sm">
            <thead>
              <tr className="text-left text-gray-500">
                <th className="py-2 pr-4">Comment</th>
                <th className="py-2 pr-4">Video</th>
                <th className="py-2 pr-4">Owner</th>
                <th className="py-2 pr-4">Timestamp</th>
                <th></th>
              </tr>
            </thead>
            <tbody>
              {data.rows.map((c: any) => (
                <tr key={c.id} className="border-t">
                  <td className="py-2 pr-4">{c.content || 'Audio comment'}</td>
                  <td className="py-2 pr-4">{c.videoTitle || `Video ${c.videoId}`}</td>
                  <td className="py-2 pr-4">{c.videoOwner}</td>
                  <td className="py-2 pr-4">{new Date(c.createdAt).toLocaleString()}</td>
                  <td className="py-2 pr-4"><button className="text-red-600" onClick={() => onDelete(c.id)}>Delete</button></td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
};

export default UserComments;


